import React from "react";
import { whyChooseUs } from "../constants/homePageConstant";


export default function WhyChooseUs({ items = whyChooseUs }) {
  return (
      <div className="w-full py-10 md:py-16">
        <h2 className="text-3xl md:text-4xl font-semibold tracking-tight">Why Choose Us</h2>
        <p className="text-gray-500 mt-2 mb-8 md:mb-12">Everything you need to know about the product and billing.</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {items.map((f) => (
            <Feature key={f.title} {...f} />
          ))}
        </div>
      </div>
  );
}

function Feature({ icon: Icon, title, quote, desc }) {
  return (
    <div className="flex items-start gap-4">
      {/* Icon circle */}
      <div className="h-14 w-14 shrink-0 rounded-full bg-white shadow-[0_6px_24px_rgba(2,132,199,0.12)] ring-1 ring-sky-100 grid place-items-center">
        <Icon className="text-sky-600 h-6 w-6" />
      </div>

      {/* Copy */}
      <div>
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        {quote && <h4 className="text-md font-medium text-gray-700 mt-1">{quote}</h4>}
        <p className="mt-2 text-gray-600 leading-7 max-w-xs">{desc}</p>
      </div>
    </div>
  );
}


